<template>
  <i class="tm-visual-anchor" :style="styleObj">
    <img
      v-show="isActive"
      src="/resources/img/vmTimeline/drop-anchor-active.png"
      alt="active"
    />
    <img
      v-show="!isActive"
      src="/resources/img/vmTimeline/drop-anchor.png"
      alt="inactive"
    />
  </i>
</template>

<script>
import { TimePoint } from '../../../api/grid';
import gridMixin from '../../grid.mixin';
import { mapState } from 'vuex';

export default {
  name: 'tm-visual-anchor',
  mixins: [gridMixin],

  props: {
    time: { type: Number, required: true },
  },

  data() {
    return {
      point: new TimePoint(),
    };
  },

  computed: {
    ...mapState('timemachine', {
      insertionTime: (state) => state.dndEscort.insertionTime,
    }),

    styleObj() {
      if (this.gridEstablished) {
        this.$_time2point(this.$props.time, true, this.$data.point);
      }

      return {
        top: `${this.$data.point.y}px`,
        left: `${this.$data.point.x}px`,
      };
    },

    isActive() {
      return this.$props.time === this.insertionTime;
    },
  },
};
</script>

<style lang="scss">
.tm-anchor > .tm-visual-anchor {
  position: absolute;
  margin-top: var(--tm-pxRowBlankTop);
  width: 36px;
  height: var(--tm-pxAssetHeight);
  transform: translateX(-50%);
  z-index: var(--tm-zVisualAnchor);
  pointer-events: none;

  > img {
    height: 100%;
  }
}
</style>
